import type { PropsWithChildren } from 'react';

import { useStorePubSub } from '@drycut/apollo';

type Props = PropsWithChildren<{
  slug: string;
}>;

export default function StorePubSubWrapper({ slug, children }: Props): React.ReactElement {
  // Real time updates for the waiting time and stylist list.
  useStorePubSub({ slug });

  return <div id="store-pubsub-wrapper">{children}</div>;
}
